module.exports = __webpack_public_path__ + "img/vertical-logo-dark.1d7c09a1.svg";